import { CURRENCY } from 'src/types';

export enum VALIDATION_TYPE {
    TIME = 'time',
    CHARGE = 'charge',
    WAIVE = 'waive',
    GUEST = 'guest',
    PRICING_PLAN_CHANGE = 'pricing_plan_change',
}

export type ValidationType = {
    id: string;
    created_at: string;
    modified_at: string;
    code: string;
    name: string;
    type: VALIDATION_TYPE;
    amount: number;
    currency: CURRENCY;
    is_active: boolean;
    can_be_stacked: boolean;
    can_be_combined: boolean;
    validator_account: string;
    is_system: boolean;
    pricing_plan_identity: string | null;
};
